import React from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../components/Button'
import Icon from '../../components/Icon'
import Private from '../../components/Private'
import Text from '../../components/Text'
import routes from '../../config/routes'
import { Container } from './styles'

interface Props {

}

const SettingsScreen: React.FC<Props> = () => {
  const history = useHistory()

  return (
    <Private>
      <Text
        style={{ marginBottom: '22px' }}
        tag="h1"
      >
        Ajustes
      </Text>
      <Container>
        <div
          onClick={() => history.push(routes.settings.account.path)}
        >
          <Button
            style={{ float: 'left', paddingLeft: '0px' }}
            before={(
              // <Icon
              //   name="account-color"
              // />
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 3C11.66 3 13 4.34 13 6C13 7.66 11.66 9 10 9C8.34 9 7 7.66 7 6C7 4.34 8.34 3 10 3ZM10 17.2C7.5 17.2 5.29 15.92 4 13.98C4.03 11.99 8 10.9 10 10.9C11.99 10.9 15.97 11.99 16 13.98C14.71 15.92 12.5 17.2 10 17.2Z"
                  fill="#868686"
                />
              </svg>

            )}
            label="Minha conta"
            backgroundColor="transparent"
            fontColor="darkGray"
          />
          <Button
            style={{ float: 'right' }}
            after={(
              <Icon
                name="arrow"
              />
            )}
            label=""
            backgroundColor="transparent"
            fontColor="darkGray"
          />

        </div>
        <div
          style={{ marginTop: '14px' }}
          onClick={() => history.push(routes.settings.menu.path)}
        >
          <Button
            style={{ float: 'left', paddingLeft: '0px' }}
            before={(
              // <Icon
              //   name="security-color"
              // />
              <svg
                width="18"
                height="22"
                viewBox="0 0 18 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 0L0 4V10C0 15.55 3.84 20.74 9 22C14.16 20.74 18 15.55 18 10V4L9 0ZM8 6H10V8H8V6ZM8 10H10V16H8V10Z"
                  fill="#868686"
                />
              </svg>

            )}
            label="Privacidade e segurança"
            backgroundColor="transparent"
            fontColor="darkGray"
          />
          <Button
            style={{ float: 'right' }}
            after={(
              <Icon

                name="arrow"
              />
            )}
            label=""
            backgroundColor="transparent"
            fontColor="darkGray"
          />

        </div>

      </Container>
    </Private>
  )
}

export default SettingsScreen
